export default "__VITE_ASSET__DrmQMnUq__"